import React from 'react';
import { LoginPage } from '../../auth';

const AgentAdminLoginPage = () => (
  <LoginPage
    title="Agent Admin Portal"
    subtitle="Manage agent allocation and live chat workflows."
    expectedRole="agentAdmin"
    expectedRoleLabel="Agent Admin"
    redirectTo="/agent-admin"
  />
);

export default AgentAdminLoginPage;
